module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="candidate-profile">\n    ';
 if (resumeReminder) { ;
__p += '\n        <div class="app-review__reminder">\n            <h1>Review</h1>\n            <p>\n                Your application is <i>almost</i> complete&mdash;you just need to\n                <b>upload your resume</b> or add your work history manually.\n            </p>\n            ';
 if (resumeReminder === 'skip') { ;
__p += '\n                <p>\n                    Set a password now so you can easily access your application later:\n                </p>\n            ';
 } else { ;
__p += '\n                <p>\n                    We\'ll remind you at ' +
__e( resumeReminder ) +
', so set a password now so\n                    you can easily access your application later:\n                </p>\n            ';
 } ;
__p += '\n\n            <div class="app-review__reminder-footer">\n                <div class="password-container"></div>\n\n                <span class="app-review__primary">\n                    <a href="/" class="js-save btn btn-large btn-primary">\n                        Save and Exit\n                    </a>\n                </span>\n                <span class="app-review__secondary">\n                    <a href="' +
__e( reminderLink ) +
'">I\'ll add my work history manually</a>\n                </span>\n            </div>\n        </div>\n    ';
 } else { ;
__p += '\n        <header class="r-header group">\n            <div>\n                <h1>Review Application</h1>\n                <p>\n                    Look over your responses one last time. When you\'re ready to\n                    go, <span class="js-enter-pw hidden-mobile">enter a password and</span> click Submit!\n                </p>\n\n                <div class="selected-jobs-list">\n                    Applying for:<br />\n                    <div class="selected-jobs">\n                        ';
 positions.forEach(function(position) { ;
__p += '\n                            ' +
__e( position.title ) +
'<br />\n                        ';
 }) ;
__p += '\n                    </div>\n                </div>\n            </div>\n            <div class="review-password-modal">\n                <div class="password-container"></div>\n                <button class="next-button btn btn-large btn-primary">\n                  Submit\n                </button>\n                <div class="app-review__auto-apply">\n                  <div>\n                    Do you want us to automatically apply to other jobs like\n                    ';
 if (positions && positions.length > 1) { ;
__p += 'these';
 } else { ;
__p += 'this one';
 } ;
__p += ' for you?\n                  </div>\n                  Auto-apply:\n                  <a href="#" class="js-auto-apply" data-autoapply="1">On</a>\n                  <span>|</span>\n                  <a href="#" class="js-auto-apply" data-autoapply="0">Off</a>\n                </div>\n            </div>\n        </header>\n    ';
 } ;
__p += '\n\n    <div class="profile-header">\n        <div class="profile-header-container">\n            <div class="edit-button">\n                <a href="#" data-step="STEP_INFO">\n                    ' +
((__t = ( $.svgIcon('pencil') )) == null ? '' : __t) +
'\n                    <span class="hidden-mobile">Edit</span>\n                </a>\n            </div>\n            <div class="profile-header-icon">\n                <div class="profile-header-initials">\n                    <span>' +
__e( user.initials ) +
'</span>\n                </div>\n            </div>\n            <div class="profile-header-content">\n                <h1 class="fs-hide">' +
__e( user.full_name ) +
'</h1>\n                <span class="profile-header-location fs-hide">' +
__e( user.city ) +
'</span>\n            </div>\n        </div>\n        <div class="profile-summary';
 if (!self_promo) { ;
__p += ' profile-no-summary';
 } ;
__p += '">\n            <div class="edit-button">\n                <a href="#" data-step="STEP_SUMMARY">\n                    ' +
((__t = ( $.svgIcon('pencil') )) == null ? '' : __t) +
'\n                    <span class="hidden-mobile">Edit</span>\n                </a>\n            </div>\n            ';
 if (self_promo) { ;
__p += '\n                <p>' +
__e( self_promo ) +
'</p>\n            ';
 } else { ;
__p += '\n                <span>Write a quick summary about yourself (Recommended)</span>\n                <a href="#" class="no-summary" data-step="STEP_SUMMARY">+Add summary</a>\n            ';
 } ;
__p += '\n        </div>\n    </div>\n\n    <section class="basic-information">\n        <header>\n            <h2>Basic Information</h2>\n            <div class="edit-button">\n                <a href="#" data-step="STEP_INFO">\n                    ' +
((__t = ( $.svgIcon('pencil', 'mobile-only') )) == null ? '' : __t) +
'\n                    <span class="hidden-mobile">Edit</span>\n                </a>\n            </div>\n        </header>\n\n        <article>\n            <table>\n                <tbody>\n                    <tr>\n                        <td>Ethnicity</td>\n                        <td class="fs-hide">' +
__e( user.ethnicity ) +
'</td>\n                        <td>' +
((__t = ( $.svgIcon('lock') )) == null ? '' : __t) +
' Not visible on profile</td>\n                    </tr>\n                    <tr>\n                        <td>Gender</td>\n                        <td class="fs-hide">' +
__e( user.gender ) +
'</td>\n                        <td>' +
((__t = ( $.svgIcon('lock') )) == null ? '' : __t) +
' Not visible on profile</td>\n                    </tr>\n                    ';
 if (user.birth_date) { ;
__p += '\n                    <tr>\n                        <td>Birthdate</td>\n                        <td class="fs-hide">' +
__e( user.birth_date ) +
'</td>\n                        <td>' +
((__t = ( $.svgIcon('lock') )) == null ? '' : __t) +
' Not visible on profile</td>\n                    </tr>\n                    ';
 } ;
__p += '\n                    ';
 if (user.veteran_status) { ;
__p += '\n                        <tr>\n                            <td>Veteran Status</td>\n                            <td class="fs-hide">' +
__e( user.veteran_status ) +
'</td>\n                            <td>' +
((__t = ( $.svgIcon('lock') )) == null ? '' : __t) +
' Not visible on profile</td>\n                        </tr>\n                    ';
 } ;
__p += '\n                    ';
 if (user.disability_status) { ;
__p += '\n                        <tr>\n                            <td>Disability Status</td>\n                            <td class="fs-hide">' +
__e( user.disability_status ) +
'</td>\n                            <td>' +
((__t = ( $.svgIcon('lock') )) == null ? '' : __t) +
' Not visible on profile</td>\n                        </tr>\n                    ';
 } ;
__p += '\n                    <tr>\n                        <td>Eligible to work in U.S.?</td>\n                        <td class="fs-hide">' +
__e( user.eligible ) +
'</td>\n                        <td></td>\n                    </tr>\n                </tbody>\n            </table>\n        </article>\n    </section>\n\n    ';
 if (!_.isEmpty(companies)) { ;
__p += '\n    <section class="r-company-questions">\n        <header>\n            <h2>Company Questions</h2>\n            <div class="edit-button">\n                <a href="#" data-step="STEP_QUESTIONS">\n                    ' +
((__t = ( $.svgIcon('pencil', 'mobile-only') )) == null ? '' : __t) +
'\n                    <span class="hidden-mobile">Edit</span>\n                </a>\n            </div>\n        </header>\n\n        ';
 _.forIn(companies, function(questions, company) { ;
__p += '\n        <article class="review-question">\n            <h4 class="questions-company-name">' +
__e( company ) +
'</h4>\n            <ul class="questions">\n                ';
 questions.forEach(function(question) { ;
__p += '\n                <li\n                    class="';

                        if (question.followup) { ;
__p += 'followup';
 }
                        if (question.response.length > LONG_ANSWER_CHARS) { ;
__p += ' long';
 } ;
__p += '"\n                >\n                    <span class="question">' +
__e( question.question ) +
'</span>\n                    <strong class="answer">' +
__e( question.value ) +
'</strong>\n                </li>\n                ';
 }) ;
__p += '\n            </ul>\n        </article>\n        ';
 }) ;
__p += '\n    </section>\n    ';
 } ;
__p += '\n\n    ';
 if (skills.length > 0) { ;
__p += '\n    <section class="r-company-questions">\n        <header>\n            <h2>Skills and Experience</h2>\n            <div class="edit-button">\n                <a href="#" data-step="STEP_SKILLS">\n                    ' +
((__t = ( $.svgIcon('pencil', 'mobile-only') )) == null ? '' : __t) +
'\n                    <span class="hidden-mobile">Edit</span>\n                </a>\n            </div>\n        </header>\n\n        <article class="review-question">\n            <ul class="questions">\n              ';
 skills.forEach(function(question) { ;
__p += '\n                  <li class="';
 if (question.followup) { ;
__p += 'followup';
 } ;
__p += '">\n                      <span class="question">' +
__e( question.question ) +
'</span>\n                      <strong class="answer">' +
__e( question.value ) +
'</strong>\n                  </li>\n              ';
 }) ;
__p += '\n              </ul>\n        </article>\n    </section>\n    ';
 } ;
__p += '\n\n    ';
 if (pref_shift_starts.length > 0) { ;
__p += '\n    <section class="r-company-questions">\n        <header>\n            <h2>Preferred Shift</h2>\n            <div class="edit-button">\n                <a href="#" data-step="STEP_SHIFT_PREFERENCE">\n                    ' +
((__t = ( $.svgIcon('pencil', 'mobile-only') )) == null ? '' : __t) +
'\n                    <span class="hidden-mobile">Edit</span>\n                </a>\n            </div>\n        </header>\n\n        <article class="review-question">\n            <ul class="questions">\n              ';
 pref_shift_starts.forEach(function(pref) { ;
__p += '\n                  <li>\n                      <span class="question">\n                          ' +
__e( pref.position.title ) +
'\n                          <small>(' +
__e( pref.position.company_name ) +
' - ' +
__e( pref.position.location_name ) +
')</small>\n                      </span>\n                      <strong class="answer">' +
__e( pref.value ) +
'</strong>\n                  </li>\n              ';
 }) ;
__p += '\n              </ul>\n        </article>\n    </section>\n    ';
 } ;
__p += '\n\n    <section class="work-experience">\n        <header>\n            <h2>Work History</h2>\n            <div class="edit-button">\n                <a href="#" data-step="STEP_HISTORY">\n                    ' +
((__t = ( $.svgIcon('pencil', 'mobile-only') )) == null ? '' : __t) +
'\n                    <span class="hidden-mobile">Edit</span>\n                </a>\n            </div>\n        </header>\n        <div>\n            ';
 if (jobs.length === 0) { ;
__p += '\n            <article>\n                <p>No work history provided.</p>\n            </article>\n            ';
 } ;
__p += '\n\n            ';
 jobs.forEach(function(job) { ;
__p += '\n            ';
 if (!job.title) { ;
__p += '\n                ';
 if (job.reason) { ;
__p += '\n                <article class="gap-explanation">\n                    <div class="job-icon">\n                        <div class="job-line"></div>\n                        <div class="gap-icon">\n                            <div></div>\n                        </div>\n                    </div>\n                    <div class="job-content">\n                        <span class="dates">' +
__e( job.start_date ) +
' &ndash; ' +
__e( job.end_date ) +
' &bull; ' +
__e( job.durationString ) +
'</span>\n                        <p class="fs-hide">\n                            ' +
__e( job.reason ) +
'\n                        </p>\n                    </div>\n                </article>\n                ';
 } ;
__p += '\n            ';
 } else { ;
__p += '\n                <article class="job-description">\n                    <div class="job-icon">\n                        <div class="job-line"></div>\n                        <div class="job-icon-container">\n                            ' +
((__t = ( $.svgIcon('briefcase') )) == null ? '' : __t) +
'\n                        </div>\n                    </div>\n                    <div class="job-content">\n                        <header>\n                            <div class="job-title">\n                              <strong class="item-title job-title__role">' +
__e( job.title ) +
'</strong>\n                              ';
 if (job.displayAsContractJob) {;
__p += '<span class="job-title__contract">Contract</span>';
 } ;
__p += '\n                            </div>\n                            <span class="company fs-hide">' +
__e( job.company ) +
'</span>\n                            <span class="dates">' +
__e( job.start_date ) +
' &ndash; ' +
__e( job.end_date ) +
' &bull; ' +
__e( job.durationString ) +
'</span>\n                        </header>\n                        <p class="duties">' +
__e( job.duties ) +
'</p>\n                        ';
 if (job.reason_for_leaving) { ;
__p += '\n                        <div class="reason-for-leaving fs-hide">\n                            Reason for leaving: ' +
__e( job.reason_for_leaving ) +
'\n                            ';
 if (job.reason_explain) { ;
__p += '\n                                (' +
__e( job.reason_explain ) +
')\n                            ';
 } ;
__p += '\n                        </div>\n                        <span class="location fs-hide">' +
__e( job.city ) +
', ' +
__e( job.state ) +
'</span>\n                        ';
 } ;
__p += '\n                    </div>\n                </article>\n            ';
 } ;
__p += '\n            ';
 }); ;
__p += '\n        </div>\n    </section>\n\n\n    ';
 if (references.length > 0) { ;
__p += '\n    <section class="r-references review-list">\n        <header>\n            <h2>Professional References</h2>\n            <div class="edit-button">\n                <a href="#" data-step="STEP_HISTORY">\n                    ' +
((__t = ( $.svgIcon('pencil', 'mobile-only') )) == null ? '' : __t) +
'\n                    <span class="hidden-mobile">Edit</span>\n                </a>\n            </div>\n        </header>\n\n        <div>\n            ';
 references.forEach(function(job) { ;
__p += '\n                <article class="icon-article fs-hide">\n                <div class="reference-meta-row">\n                    <div class="icon-container">\n                        ' +
((__t = ( $.svgIcon('profile') )) == null ? '' : __t) +
'\n                    </div>\n                    <div class="reference-meta">\n                        <div class="manager-info">\n                            <span class="manager-name">' +
__e( job.managerName ) +
'</span>\n                            <span class="manager-title">\n                                ' +
__e( job.reference_relationship ) +
'\n                            </span>\n                        </div>\n                        <span class="manager-phone">\n                            ' +
((__t = ( $.svgIcon('phone') )) == null ? '' : __t) +
'\n                            <span>' +
__e( job.managerNumber ) +
'</span>\n                        </span>\n                    </div>\n                </div>\n                ';
 if (job.reference_confirmed) { ;
__p += '\n                    <div class="reference-message">\n                        ';
 if (job.reference_other) { ;
__p += '\n                            "' +
__e( job.reference_other ) +
'"\n                        ';
 } ;
__p += '\n                        <div class="confirmed-reference">\n                            ' +
((__t = ( $.svgIcon('approve') )) == null ? '' : __t) +
'Verified ' +
__e( user.first_name ) +
'\'s employment\n                        </div>\n                    </div>\n                ';
 } ;
__p += '\n                </article>\n            ';
 }) ;
__p += '\n        </div>\n    </section>\n    ';
 } ;
__p += '\n\n    ';
 if (schools.length > 0 ) { ;
__p += '\n    <section class="review-list">\n        <header>\n            <h2>Education</h2>\n            <div class="edit-button">\n                <a href="#" data-step="STEP_INFO">\n                    ' +
((__t = ( $.svgIcon('pencil', 'mobile-only') )) == null ? '' : __t) +
'\n                    <span class="hidden-mobile">Edit</span>\n                </a>\n            </div>\n        </header>\n\n        <div>\n            ';
 schools.forEach(function(school) { ;
__p += '\n            <article class="icon-article">\n                <div class="icon-container">\n                    ' +
((__t = ( $.svgIcon('education') )) == null ? '' : __t) +
'\n                </div>\n                <div>\n                    ';
 if (school.name) { ;
__p += '\n                      <strong class="school-name fs-hide">' +
__e( school.name ) +
'</strong>\n                    ';
 } ;
__p += '\n                    <span class="degree-type">' +
__e( school.degree_type_string ) +
'</span>\n                    ';
 if (school.degree_major) { ;
__p += '\n                      <span>' +
__e( school.degree_major ) +
'</span>\n                    ';
 } ;
__p += '\n                </div>\n            </article>\n            ';
 }) ;
__p += '\n        </div>\n    </section>\n    ';
 } ;
__p += '\n\n    <section>\n        <header>\n            <h2>Availability</h2>\n            <div class="edit-button">\n                <a href="#" data-step="STEP_AVAILABILITY">\n                    ' +
((__t = ( $.svgIcon('pencil', 'mobile-only') )) == null ? '' : __t) +
'\n                    <span class="hidden-mobile">Edit</span>\n                </a>\n            </div>\n        </header>\n        <article>\n            <div id="availability" class="availability-container"></div>\n        </article>\n    </section>\n\n    <div class="password-auth-modal" style="display:none;">\n        <h2>Set up your account</h2>\n        <div class="modal-content"></div>\n        <button class="finish-button btn btn-large btn-primary">\n          Finish\n        </button>\n    </div>\n</div>\n';

}
return __p
}